/**
 * City Beauty Regimen Accordion Section - Shopify Compatible JavaScript
 * Handles accordion functionality including collapse/expand, lazy loading, and responsive behavior
 */

(function() {
    'use strict';

    // Regimen accordion configuration
    const regimenAccordionConfig = {
        sectionSelector: '.cb-regimen-accordion',
        lazyClass: 'lazy',
        loadedClass: 'loaded',
        animateClass: 'animate',
        dataLoader: 'component',
        accordion: {
            selector: '.cb-regimen-accordion',
            buttonSelector: '.regimen-collapse',
            contentSelector: '.regimen-collapse-content',
            activeClass: 'show',
            expandedAttr: 'aria-expanded',
            targetAttr: 'data-target',
            toggleAttr: 'data-toggle'
        },
        defaultSteps: [
            {
                id: 'regimen-1',
                title: '01 | Cleanse',
                content: 'Cleansing step content'
            },
            {
                id: 'regimen-2',
                title: '02 | Exfoliate',
                content: 'Exfoliation step content'
            },
            {
                id: 'regimen-3',
                title: '03 | Light Therapy Treatment',
                content: 'Light therapy step content'
            },
            {
                id: 'regimen-4',
                title: '04 | Mask',
                content: 'Mask step content'
            },
            {
                id: 'regimen-5',
                title: '05 | For The Eyes',
                content: 'Eye care step content'
            },
            {
                id: 'regimen-6',
                title: '06 | Serums',
                content: 'Serum step content'
            },
            {
                id: 'regimen-7',
                title: '07 | Moisturize',
                content: 'Moisturizer step content'
            },
            {
                id: 'regimen-8',
                title: '08 | Targeted Treatments',
                content: 'Targeted treatment step content'
            }
        ]
    };

    /**
     * Initialize Regimen Accordion section components
     */
    function initCityBeautyRegimenAccordionComponents() {
        // console.log('Initializing City Beauty Regimen Accordion components...');
        
        // Initialize lazy loading
        initLazyLoading();
        
        // Initialize animations
        initAnimations();
        
        // Initialize accordion functionality
        initAccordion();
        
        // Handle responsive behavior
        handleRegimenAccordionResize();
        
        // console.log('City Beauty Regimen Accordion components initialized successfully');
    }

    /**
     * Initialize lazy loading for the section
     */
    function initLazyLoading() {
        const sections = document.querySelectorAll(`${regimenAccordionConfig.sectionSelector}.${regimenAccordionConfig.lazyClass}`);
        
        if (sections.length === 0) {
            return;
        }

        // Check if Intersection Observer is supported
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadSection(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                root: null,
                rootMargin: '50px',
                threshold: 0.1
            });

            sections.forEach(section => {
                observer.observe(section);
            });
        } else {
            // Fallback for browsers without Intersection Observer
            sections.forEach(section => {
                loadSection(section);
            });
        }
    }

    /**
     * Load a lazy section
     */
    function loadSection(section) {
        // Remove lazy class and add loaded class
        section.classList.remove(regimenAccordionConfig.lazyClass);
        section.classList.add(regimenAccordionConfig.loadedClass);
        
        // Trigger animation after a short delay
        setTimeout(() => {
            section.classList.add(regimenAccordionConfig.animateClass);
        }, 100);
        
        // Initialize accordion for this section
        initAccordionForSection(section);
        
        console.log('Regimen Accordion section loaded');
    }

    /**
     * Initialize animations
     */
    function initAnimations() {
        const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
        
        sections.forEach(section => {
            // Add animation class if section is already visible
            if (isElementInViewport(section)) {
                section.classList.add(regimenAccordionConfig.animateClass);
            }
        });
    }

    /**
     * Check if element is in viewport
     */
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /**
     * Initialize accordion functionality
     */
    function initAccordion() {
        const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
        
        sections.forEach(section => {
            initAccordionForSection(section);
        });
    }

    /**
     * Initialize accordion for a specific section
     */
    function initAccordionForSection(section) {
        // The section itself is the accordion
        const accordion = section;
        
        const buttons = accordion.querySelectorAll(regimenAccordionConfig.accordion.buttonSelector);
        const contents = accordion.querySelectorAll(regimenAccordionConfig.accordion.contentSelector);
        
        // Initialize each accordion item
        buttons.forEach((button, index) => {
            const targetId = button.getAttribute(regimenAccordionConfig.accordion.targetAttr);
            const content = accordion.querySelector(targetId);
            
            if (!content) {
                return;
            }
            
            // Set initial state
            const isExpanded = button.getAttribute(regimenAccordionConfig.accordion.expandedAttr) === 'true';
            button.setAttribute(regimenAccordionConfig.accordion.expandedAttr, isExpanded);
            
            // Set active class based on initial state
            if (isExpanded) {
                content.classList.add(regimenAccordionConfig.accordion.activeClass);
                button.classList.add('active');
                
                // Force chevron rotation for first item immediately
                if (index === 0) {
                    button.style.setProperty('--chevron-rotation', '90deg');
                }
            } else {
                content.classList.remove(regimenAccordionConfig.accordion.activeClass);
                button.classList.remove('active');
            }
            
            // Add click event listener
            button.addEventListener('click', (e) => {
                e.preventDefault();
                
                
                // Toggle checkbox for CSS-only rotation
                const checkbox = document.getElementById(button.id + '-checkbox');
                if (checkbox) {
                    checkbox.checked = !checkbox.checked;
                }
                
                toggleAccordionItem(button, content, accordion);
            });
        });
    }

    /**
     * Toggle accordion item
     */
    function toggleAccordionItem(button, content, accordion) {
        // Check if content is currently visible (more reliable than aria-expanded)
        const isExpanded = content.classList.contains(regimenAccordionConfig.accordion.activeClass);
        
        
        if (isExpanded) {
            // Collapse
            collapseAccordionItem(button, content);
        } else {
            // Expand
            expandAccordionItem(button, content, accordion);
        }
    }

    /**
     * Collapse accordion item
     */
    function collapseAccordionItem(button, content) {
        button.setAttribute(regimenAccordionConfig.accordion.expandedAttr, 'false');
        button.classList.remove('active');
        content.classList.remove(regimenAccordionConfig.accordion.activeClass);
        
        // Force chevron rotation for first item
        if (button.id === 'regimen-1') {
            button.style.setProperty('--chevron-rotation', '0deg');
        }
    }

    /**
     * Expand accordion item
     */
    function expandAccordionItem(button, content, accordion) {
        // Close other open items if needed (optional - can be configured)
        const closeOthers = accordion.dataset.closeOthers !== 'false';
        
        if (closeOthers) {
            const allButtons = accordion.querySelectorAll(regimenAccordionConfig.accordion.buttonSelector);
            const allContents = accordion.querySelectorAll(regimenAccordionConfig.accordion.contentSelector);
            
            allButtons.forEach(btn => {
                if (btn !== button) {
                    const targetId = btn.getAttribute(regimenAccordionConfig.accordion.targetAttr);
                    const targetContent = accordion.querySelector(targetId);
                    if (targetContent && targetContent.classList.contains(regimenAccordionConfig.accordion.activeClass)) {
                        collapseAccordionItem(btn, targetContent);
                    }
                }
            });
        }
        
        button.setAttribute(regimenAccordionConfig.accordion.expandedAttr, 'true');
        button.classList.add('active');
        content.classList.add(regimenAccordionConfig.accordion.activeClass);
        
        // Force chevron rotation for first item
        if (button.id === 'regimen-1') {
            button.style.setProperty('--chevron-rotation', '90deg');
        }
    }

    /**
     * Handle responsive behavior
     */
    function handleRegimenAccordionResize() {
        const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
        
        if (sections.length === 0) {
            return;
        }

        function updateResponsiveDisplay() {
            sections.forEach(section => {
                const accordion = section.querySelector(regimenAccordionConfig.accordion.selector);
                
                if (!accordion) {
                    return;
                }
                
                const titles = accordion.querySelectorAll('.regimen-collapse-title');
                const contents = accordion.querySelectorAll('.regimen-collapse-content');
                
                // Update title font sizes based on screen size
                titles.forEach(title => {
                    if (window.innerWidth <= 480) {
                        title.style.fontSize = '20px';
                    } else if (window.innerWidth <= 575.98) {
                        title.style.fontSize = '22px';
                    } else if (window.innerWidth <= 767.98) {
                        title.style.fontSize = '26px';
                    } else {
                        title.style.fontSize = '32px';
                    }
                });
                
                // Update content padding based on screen size
                contents.forEach(content => {
                    if (window.innerWidth <= 480) {
                        content.style.padding = '10px 0';
                    } else if (window.innerWidth <= 575.98) {
                        content.style.padding = '15px 0';
                    } else {
                        content.style.padding = '20px 0';
                    }
                });
            });
        }

        // Initial call
        updateResponsiveDisplay();

        // Listen for resize events
        window.addEventListener('resize', debounce(updateResponsiveDisplay, 250));
    }

    /**
     * Debounce function to limit function calls
     */
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    /**
     * Initialize accessibility features
     */
    function initAccessibility() {
        const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
        
        sections.forEach(section => {
            const accordion = section.querySelector(regimenAccordionConfig.accordion.selector);
            
            if (!accordion) {
                return;
            }
            
            // Add ARIA labels for accordion
            accordion.setAttribute('role', 'tablist');
            accordion.setAttribute('aria-label', 'Regimen steps accordion');
            
            const buttons = accordion.querySelectorAll(regimenAccordionConfig.accordion.buttonSelector);
            const contents = accordion.querySelectorAll(regimenAccordionConfig.accordion.contentSelector);
            
            buttons.forEach((button, index) => {
                const content = contents[index];
                
                if (content) {
                    // Add ARIA attributes
                    button.setAttribute('role', 'tab');
                    button.setAttribute('aria-controls', content.id);
                    button.setAttribute('aria-selected', button.getAttribute(regimenAccordionConfig.accordion.expandedAttr) === 'true');
                    
                    content.setAttribute('role', 'tabpanel');
                    content.setAttribute('aria-labelledby', button.id);
                    
                    // Add keyboard navigation
                    button.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            button.click();
                        }
                    });
                }
            });
        });
    }

    /**
     * Generate accordion step HTML
     */
    function generateAccordionStepHTML(step, index) {
        const stepNumber = String(index + 1).padStart(2, '0');
        const isFirst = index === 0;
        
        return `
            <button class="regimen-collapse title-box" id="${step.id}" data-toggle="collapse" data-target="#${step.id}-content" aria-expanded="${isFirst}">
                <h2 class="regimen-collapse-title">${stepNumber} | ${step.title}</h2>
            </button>
            <div class="regimen-collapse-content collapse${isFirst ? ' show' : ''}" id="${step.id}-content">
                <div class="row">
                    <div class="col-md-6 pt-10">
                        <p>${step.description || step.content}</p>
                        ${step.howToUse ? `<p style="margin-top: 10px;"><b>How to Use:</b></p><p>${step.howToUse}</p>` : ''}
                        ${step.recommendation ? `<p style="margin-top: 10px;"><b>We recommend:</b></p><a class="link" href="${step.recommendationUrl || '#'}">${step.recommendation}</a>` : ''}
                    </div>
                    <div class="col-md-6 pl-30">
                        ${step.image ? `<img src="${step.image}" width="344" height="213" alt="${step.title} Steps">` : ''}
                        ${step.avoidList ? `<p><b>Avoid ${step.title.toLowerCase()} containing:</b></p><ul>${step.avoidList.map(item => `<li>${item}</li>`).join('')}</ul>` : ''}
                        ${step.insiderTip ? `<p><b>City Beauty insider tip: </b></p><p>${step.insiderTip}</p>` : ''}
                    </div>
                </div>
            </div>
            ${index < regimenAccordionConfig.defaultSteps.length - 1 ? '<hr>' : ''}
        `;
    }

    /**
     * Populate accordion with default steps (if accordion is empty)
     */
    function populateAccordionSteps() {
        const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
        
        sections.forEach(section => {
            const accordion = section.querySelector(regimenAccordionConfig.accordion.selector);
            
            if (accordion && accordion.children.length === 0) {
                // Generate HTML for all steps
                let stepsHTML = '';
                regimenAccordionConfig.defaultSteps.forEach((step, index) => {
                    stepsHTML += generateAccordionStepHTML(step, index);
                });
                
                accordion.innerHTML = stepsHTML;
                
                // Re-initialize accordion for this section
                initAccordionForSection(section);
            }
        });
    }

    /**
     * Initialize customizer support
     */
    function initCustomizerSupport() {
        if (window.Shopify && window.Shopify.designMode) {
            // Listen for section load events
            document.addEventListener('shopify:section:load', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            // Listen for section select events
            document.addEventListener('shopify:section:select', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            // Listen for section reorder events
            document.addEventListener('shopify:section:reorder', function(event) {
                const sections = document.querySelectorAll(regimenAccordionConfig.sectionSelector);
                sections.forEach(section => {
                    loadSection(section);
                });
            });
            
            // Listen for block add/remove events
            document.addEventListener('shopify:block:select', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            document.addEventListener('shopify:block:deselect', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            // Listen for block add events
            document.addEventListener('shopify:block:add', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            // Listen for block remove events
            document.addEventListener('shopify:block:remove', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
            
            // Listen for setting changes
            document.addEventListener('shopify:section:setting:change', function(event) {
                const section = event.target.querySelector(regimenAccordionConfig.sectionSelector);
                if (section) {
                    loadSection(section);
                }
            });
        }
    }

    /**
     * Initialize all components
     */
    function initAll() {
        initCityBeautyRegimenAccordionComponents();
        initAccessibility();
        populateAccordionSteps();
        initCustomizerSupport();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    // Export functions for external use
    window.CityBeautyRegimenAccordion = {
        init: initCityBeautyRegimenAccordionComponents,
        loadSection: loadSection,
        handleResize: handleRegimenAccordionResize,
        initLazyLoading: initLazyLoading,
        initAnimations: initAnimations,
        initAccordion: initAccordion,
        toggleAccordionItem: toggleAccordionItem,
        expandAccordionItem: expandAccordionItem,
        collapseAccordionItem: collapseAccordionItem,
        populateAccordionSteps: populateAccordionSteps,
        generateAccordionStepHTML: generateAccordionStepHTML,
        initCustomizerSupport: initCustomizerSupport
    };

})();
